function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.051 9.683L4.27 7.256a1.5 1.5 0 01.967-1.887L19.143.89a1.5 1.5 0 011.887.968l2.08 6.456a1.5 1.5 0 01-.968 1.888l-4.825 1.554",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.317 18.683v2.571a1.935 1.935 0 01-1.941 1.929H2.758a1.935 1.935 0 01-1.941-1.929v-9.643a1.934 1.934 0 011.941-1.928h12.618a1.934 1.934 0 011.941 1.928v2.572M4.567 9.698v13.485",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.144 14.183a2.169 2.169 0 00-2.077 2.25 2.169 2.169 0 002.077 2.25h3.635a1.085 1.085 0 001.038-1.125v-2.25a1.084 1.084 0 00-1.038-1.125z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.225 15.96a.375.375 0 11-.375.375.375.375 0 01.375-.375M12.229 7.5a1.5 1.5 0 012.781.27",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgCashPaymentWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgCashPaymentWallet;